import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  //Colores corporativos:
  //PANTONE 1655 C: "#fc4c02" (naranjo)
  //PANTONE 647 C: "#236192" (azul)
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: colors.blue,
        secondary: colors.orange.darken1,
        orange: "#fc4c02", //PANTONE 1655 C
        blue2: "#236192", //PANTONE 647 C
        accent: colors.blueGrey.lighten1,
        error: colors.red.lighten1,
        info: colors.blue.lighten2,
        success: colors.green,
        warning: colors.yellow.lighten1,
        back1: colors.blue.lighten4,
        back2: colors.blue.lighten5,
        back3: colors.shades.white,
        cCustom: colors.shades.black
     
      },
      dark: {
        primary: colors.blue.darken2,
        secondary: colors.orange.darken2,
        orange: "#E54300",
        blue2: "#163955",
        accent: colors.blueGrey.darken1,
        error: colors.red.darken1,
        info: colors.blue.darken1,
        success: colors.green.darken1,
        warning: colors.yellow.darken1,
        back1: colors.blue.lighten4,
        back2: colors.blue.lighten5,
        back3: "#3A3231",
        cCustom: colors.shades.black
      },
    },
  },
});
